var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgComment(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.1998 9.0002C16.1998 12.4796 12.9763 15.3002 8.9998 15.3002C7.65733 15.3002 6.40067 14.9787 5.3249 14.4189L1.7998 15.3002L3.00428 12.4898C2.24333 11.4908 1.7998 10.2908 1.7998 9.0002C1.7998 5.5208 5.02335 2.7002 8.9998 2.7002C12.9763 2.7002 16.1998 5.5208 16.1998 9.0002ZM6.2998 8.1002H4.4998V9.9002H6.2998V8.1002ZM13.4998 8.1002H11.6998V9.9002H13.4998V8.1002ZM8.0998 8.1002H9.89981V9.9002H8.0998V8.1002Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgComment);
export default __webpack_public_path__ + "static/media/comment.76dcc103a54e897941dad25f64d47734.svg";
export { ForwardRef as ReactComponent };